/** Shape of a username, also enforced by the database: 3 to 20 ASCII letters, digits or underscores. */
export const USERNAME_PATTERN = /^[A-Za-z0-9_]{3,20}$/

/**
 * Whether `name` has the shape of a username. Whether it is free is for the API to say.
 * @param name - What was typed.
 * @returns `true` when the format is right.
 */
export function isValidUsername(name: string): boolean {
  return USERNAME_PATTERN.test(name)
}

/** Shortest password auth accepts (`GOTRUE_PASSWORD_MIN_LENGTH` on the server). */
export const MIN_PASSWORD_LENGTH = 10

/** Longest message, in characters; the database has the final say. */
export const MAX_MESSAGE_LENGTH = 144

/** Version of the Terms of Use, recorded in the profile at sign-up. Change it with the terms page. */
export const TERMS_VERSION = '2026-10-20'
